import { createReducer, on } from '@ngrx/store';
import { i18nActions } from '../i18n/i18n.actions';
import { AuthFirmType, UserType } from '../types';
import { UserActions } from '../users/users.actions';
import { AuthActions } from './auth.actions';

export interface AuthState {
  firms: AuthFirmType[] | null;
  user: (UserType & { firm: UserType['firm'] & { id: number } }) | null;
  error: unknown;
  authSpinner: boolean;
  redirectUrl: string | null;
}

export const initialAuthState: AuthState = {
  firms: null,
  user: null,
  error: null,
  authSpinner: false,
  redirectUrl: null,
};

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.loginSpinnerStart, (state) => ({ ...state, authSpinner: true })),
  on(AuthActions.loginSpinnerStopp, (state) => ({ ...state, authSpinner: false })),
  on(AuthActions.loadCurrentUserSuccessful, (state, { user }) => ({ ...state, user, error: null })),
  on(AuthActions.loadCurrentUserFailed, (state, { error }) => ({ ...state, error, user: null })),
  on(UserActions.patchCurrentUserPropertiesSucceeded, (state, { userId, firmCorporateIdentity, properties }) => {
    if (state.user?.id !== userId || state.user?.firm.corporateIdentity !== firmCorporateIdentity) {
      return state;
    }
    return { ...state, user: { ...state.user, properties: { ...properties } } };
  }),
  on(AuthActions.resetAuthStateAndStorage, () => ({ ...initialAuthState })),
  on(AuthActions.setRedirectAfterLoginSuccessful, (state, { redirectUrl }) => ({ ...state, redirectUrl })),
  on(AuthActions.clearRedirectUrl, (state) => ({ ...state, redirectUrl: null })),

  on(AuthActions.setFirms, (state, { firms }) => ({ ...state, firms })),

  on(i18nActions.languageChanged, (state, { languageCode }) => ({
    ...state,
    user: { ...state.user, languageCode },
  })),
);
